import { type TranslateFunction } from 'lib/tolgee'

import { TOLGEE_KEYS } from './translate'

export const getMockedAnswers = (t: TranslateFunction) => [
  {
    question: t(TOLGEE_KEYS.whatIsSoaQuestion),
    answer: t(TOLGEE_KEYS.whatIsSoaAnswer),
  },
  {
    question: t(TOLGEE_KEYS.isItGoodQuestion),
    answer: t(TOLGEE_KEYS.isItGoodAnswer),
  },
  {
    question: t(TOLGEE_KEYS.whatInsightsQuestion),
    answer: t(TOLGEE_KEYS.whatInsightsAnswer),
  },
  {
    question: t(TOLGEE_KEYS.whatInsightsDailyQuestion),
    answer: t(TOLGEE_KEYS.whatInsightsDailyAnswer),
  },
]
